import { useAppDispatch } from 'store/hooks';
import { closeModal, openModal } from 'features/modal/modalSlice';
import { Trans, useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { useRestreamer } from 'features/restreamer/useRestreamer';

const RestreamingE2eeConsentModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const { isFeatureAvailable } = useRestreamer();

  useEffect(() => {
    if (!isFeatureAvailable) {
      dispatch(closeModal('restreamingE2eeConsent'));
    }
  }, [isFeatureAvailable, dispatch]);

  const handleOk = () => {
    dispatch(openModal('restreamingConfig'));
    dispatch(closeModal('restreamingE2eeConsent'));
  };

  const handleCancel = () => {
    dispatch(closeModal('restreamingE2eeConsent'));
  };

  return (
    <ConfirmationDialog
      open
      maxWidth="sm"
      title={t('restreaming.e2ee_consent.title')}
      description={
        <Trans
          i18nKey="modals:restreaming.e2ee_consent.description"
          t={t}
          components={[
            // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
            <a
              href="https://docs.digitalsamba.com/dashboard/configuring-your-room-defaults/general-settings"
              target="_blank"
              rel="noopener noreferrer"
            />,
          ]}
        />
      }
      cancelText={t('restreaming.e2ee_consent.btn_cancel_label')}
      okText={t('restreaming.e2ee_consent.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
      preventClose
      hideCloseButton
    />
  );
};

export default RestreamingE2eeConsentModal;
